import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
} from "antd";
import React from "react";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import Notes from "../../../../../components/common/Notes";
import PageHeading from "../../../../../components/common/PageHeading";

const ApplicationFee = () => {
  return (
    <div className="ApplicationFee">
      <PageHeading heading="New Application Fee Receipt" />
      <Form layout="vertical" name="basic" autoComplete="off">
        <Card>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Received From" name="ReceivedFrom" required>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Amount Received" name="AmountReceived" required>
                <InputNumber
                  addonBefore={<i className="fa-solid fa-dollar-sign"></i>}
                  defaultValue="0"
                  step="0.00"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Property" name="Property" required>
                <Select
                  showArrow
                  allowClear
                  placeholder="Start typing to search"
                  style={{
                    width: "100%  ",
                  }}
                  options={[
                    {
                      label: "23291: Rental Income Account",
                      value: "23291: Rental Income Account",
                    },
                    {
                      label: "23292: Security Deposits Bank Account",
                      value: "23292: Security Deposits Bank Account",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Unit" name="unit">
                <Select
                  showArrow
                  allowClear
                  style={{
                    width: "100%  ",
                  }}
                  options={[
                    {
                      label: "23291: Rental Income Account",
                      value: "23291: Rental Income Account",
                    },
                    {
                      label: "23292: Security Deposits Bank Account",
                      value: "23292: Security Deposits Bank Account",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="GL Account" name="GLAccount" required>
                <Select
                  showArrow
                  allowClear
                  placeholder="Start typing to search"
                  style={{
                    width: "100%  ",
                  }}
                  options={[
                    {
                      label: "Cash",
                      options: [
                        {
                          label: "23291: Rental Income Account",
                          value: "23291: Rental Income Account",
                        },
                        {
                          label: "23292: Security Deposits Bank Account",
                          value: "23292: Security Deposits Bank Account",
                        },
                      ],
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Receipt Date" name="ReceiptDate" required>
                <DatePicker style={{width:'100%'}}/>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Posting Date" name="PostingDate" required>
                <DatePicker style={{width:'100%'}}/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
            <Form.Item label="Reference" name="Reference">
                <Input/>
              </Form.Item>
            </Col>
            <Col span={12}>
            <Form.Item label="Remarks" name="Remarks">
                <Input/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
            <Form.Item label="Cash Account" name="CashAccount">
            <Select
                  showArrow
                  allowClear
                  placeholder="Automatic"
                  style={{
                    width: "100%  ",
                  }}
                  options={[
                    {
                      label: "Cash",
                      options: [
                        {
                          label: "23291: Rental Income Account",
                          value: "23291: Rental Income Account",
                        },
                        {
                          label: "23292: Security Deposits Bank Account",
                          value: "23292: Security Deposits Bank Account",
                        },
                      ],
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>

        </Card>
        <br />
        <Row gutter={16}>
          <Col>
            <Button type="primary">Save & Add Another</Button>
          </Col>
          <Col>
            <Button>Save</Button>
          </Col>
          <Col>
            <Button>
              Cancel
            </Button>
          </Col>
        </Row>
        <br />
        <Row gutter={[0, 24]}>
          <Col span={24}>
            {/* <Notes /> */}
          </Col>
          <Col span={24}>
            {/* <AttachmentsUpload /> */}
          </Col>
        </Row>
      </Form>

      <div className="RightSidebar"></div>
    </div>
  );
};

export default ApplicationFee;
